import React from "react";
import { TutorialVideos } from "../instructions";
import "./Login.css";

function HomeTutorial() {
    return <TutorialVideos isPublic />;
}

export default HomeTutorial;
